module.exports = __webpack_public_path__ + "img/11.0f6d8e47.png";